import { createContext, useContext } from "react";
import useHoverScreenReader from "../hooks/useHoverScreenReader";

const ScreenReaderContext = createContext(null);

export const ScreenReaderProvider = ({ children }) => {
  const screenReader = useHoverScreenReader();

  return (
    <ScreenReaderContext.Provider value={screenReader}>
      {children}
    </ScreenReaderContext.Provider>
  );
};

export const useScreenReader = () => {
  const context = useContext(ScreenReaderContext);

  if (!context) {
    throw new Error("useScreenReader must be used within ScreenReaderProvider");
  }

  return context;
};
